<template>
  <div id="cebeo_user_form">
    <c-input :type="'text'" v-model:value="user.company"
             :placeholder="$t('cebeoUser.companyName')"/>

    <div id="name_div">
      <c-input v-model:value="user.familyName" :type="'text'"
               :placeholder="$t('customer.name')"/>
      <c-input class="first_name" v-model:value="user.firstName" :type="'text'"
               :placeholder="$t('customer.firstName')"/>
    </div>

    <c-input :type="'text'" v-model:value="user.customerNumber"
             :placeholder="$t('cebeoUser.customerNumber')"/>
    <c-input :type="'text'" v-model:value="user.email" :placeholder="$t('customer.email')"
             :class="{'border border-red-500': emailError}"/>
    <c-input :type="'text'" v-model:value="user.gsm"
             :placeholder="$t('customer.gsm')"/>
    <p>
      {{ $t('cebeoUser.noAccount') }}
      <a :href="requestAccountLink" target="_blank"> {{ $t('cebeoUser.clickHere') }}</a>.
    </p>
  </div>
</template>

<script>
import Input from '@/components/form/Input';
import validation from '@/mixins/validation';

export default {
  name: 'CebeoAccountForm',

  mixins: [validation],

  props: {
    user: { required: true }
  },

  components: {
    'c-input': Input,
  },

  computed: {
    emailError() {
      return !this.isValidEmail(this.user.email) && this.user.email.length !== 0;
    },

    locale() {
      return this.$root.$i18n.locale;
    },

    requestAccountLink() {
      if (this.locale === 'nl') {
        return 'https://www.cebeo.be/nl-be/klant-worden/ik-wil-klant-worden-bij-cebeo';
      }

      return 'https://www.cebeo.be/fr-be/devenir-client/devenir-client';
    }
  },

  methods: {
    openUserRequest(e) {
      e.preventDefault();
      window.open(`https://www.cebeo.be/${this.$root.$i18n.locale}-be/klant-worden/ik-wil-klant-worden-bij-cebeo`, '_blank');
    }
  }
};
</script>
<style scoped>
a {
  @apply text-cebeo_blue underline
}

#cebeo_user_form {
  max-width: 600px;
  @apply grid grid-rows-5 gap-y-5 m-0 mx-auto text-left;
}

#name_div > * {
  width: 49%;
}

#name_div {
  @apply flex justify-between
}

@media only screen and (max-width: 800px) {
  #cebeo_user_form {
    max-width: 600px;
    @apply flex flex-col gap-y-5 m-0 mx-auto;
  }

  #name_div > * {
    width: 100%;
  }

  #name_div {
    @apply flex flex-col
  }

  .first_name {
    @apply mt-5;
  }
}
</style>
